import { useTranslation } from 'react-i18next';
import { Box, Grid, TextField } from '@mui/material';
import { ContactDetails } from '../../../../app/services/api/ofdClient';

interface OnboardingContactDetailsProps {
  formData: ContactDetails;
  handleChange: Function;
}

const OnboardingContactDetails: React.FC<OnboardingContactDetailsProps> = ({ formData, handleChange }) => {
  const { t } = useTranslation('onboardingWizard');
  const textFieldMargin = { mb: 8 };

  return (
    <Box sx={{ p: 6, paddingBottom: 0 }}>
      <Grid container
        spacing={3}>
        <Grid item
          xs={12}
          sx={{ pr: 4 }}
          md={6}>
          <TextField fullWidth
            required
            label={t('contactTab.name')}
            value={formData.name}
            onChange={(e) => handleChange(e, 'name')}
            sx={textFieldMargin} />
          <TextField fullWidth
            required
            label={t('contactTab.jobTitle')}
            value={formData.jobTitle}
            onChange={(e) => handleChange(e, 'jobTitle')}
            sx={textFieldMargin} />
          <TextField fullWidth
            required
            label={t('contactTab.email')}
            value={formData.email}
            onChange={(e) => handleChange(e, 'email')}
            sx={textFieldMargin} />
          <TextField fullWidth
            required
            label={t('contactTab.phoneNumber')}
            value={formData.phoneNumber}
            onChange={(e) => handleChange(e, 'phoneNumber')}
            sx={textFieldMargin} />
          <TextField fullWidth
            required
            label={t('contactTab.interestReason')}
            value={formData.interestReason}
            onChange={(e) => handleChange(e, 'interestReason')}
            sx={textFieldMargin} />
          <TextField fullWidth
            required
            label={t('contactTab.rangeRequirements')}
            value={formData.rangeRequirements}
            onChange={(e) => handleChange(e, 'rangeRequirements')}
            sx={textFieldMargin} />
          <TextField fullWidth
            required
            label={t('contactTab.serviceNeeds')}
            value={formData.serviceNeeds}
            onChange={(e) => handleChange(e, 'serviceNeeds')}
            sx={textFieldMargin} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default OnboardingContactDetails;

